import React, { useState, useEffect, useContext } from "react";
import ActionTypeTab from "./ActionTypeTab";
import RecommendedActions from "../Dashboard/Component/ActionComponent/Actions";

import { AuthContext } from "../../context/auth-context";
import {
  getActionMetricsData,
  getAllBrands,
  getCustomerActiveMonitoringRecords,
  getCustomerCases,
  getRecommendedActions,
} from "../../services/apiService";
import useQuery from "../../Component/devDashboard2/common/useQuery";
import { useDispatch, useSelector } from "react-redux";
import { fetchActionMetrics } from "../../redux/actions/metricActions";

import ActionsView from "../Dashboard/Component/ActionComponent/ActionsView";
import ActionList from "../Dashboard/Component/ActionComponent/ActionList";
import { generateCombinations } from "../../utils/actions-helpers";

export default function Actions() {
  const { user } = useContext(AuthContext);
  const customerId = user?.customer_id || 0;
  const isCompanyUser = user?.user_role?.role?.name === "Company user";
  const query = useQuery();
  const actionTab = query.get("actions_list")
    ? "Actions List"
    : "Recommended Actions";
  const [actionType, setActionType] = useState(actionTab);
  const [isLoading, setIsLoading] = useState(false);
  const [actionMetricsData, setActionMetricsData] = useState([]);
  const [sourceAliasIds, setSourceAliasIds] = useState([]);
  const actionMetrics = useSelector((state) => state.actionMetrics);
  const [brandDomains, setBrandDomains] = useState();
  const [brandProductDomains, setBrandProductDomains] = useState();
  const [actionableData, setActionableData] = useState([]);

  const dispatch = useDispatch();

  const handleActionTypeChange = (key) => {
    setActionType(key);
  };

  useEffect(() => {
    fetchActionMetricsData();
  }, []);

  const fetchActionMetricsData = async () => {
    try {
      setIsLoading(true);
      const allBrands = await getAllBrands();
      const { brand: brandInfo, brandProducts: brandProductInfo } =
        allBrands?.data || {};

      const createDomainMap = (data, key = "domain_url") =>
        data?.reduce((acc, item) => {
          acc[item.name] = item[key];
          return acc;
        }, {});

      setBrandDomains(createDomainMap(brandInfo));
      setBrandProductDomains(createDomainMap(brandProductInfo));
      // let data = await getRecommendedActions(customerId);
      // const caseData = await getCustomerCases(customerId);
      const caseData = await getCustomerActiveMonitoringRecords(customerId)
      // if (data?.finalProcessedData && data?.finalProcessedData.length > 0) {
      //   const result = generateCombinations(data?.finalProcessedData, caseData);
      //   setActionMetricsData(result || []);
      //   setActionableData(data?.finalProcessedData || []);
      //   setSourceAliasIds(data?.source_alias_ids);
      //   return;
      // } else {
      const payload = { customerId, isCompanyUser };
      let data = await getActionMetricsData(payload);
      const result = generateCombinations(data?.finalProcessedData, caseData);
      setActionMetricsData(result || []);
      setActionableData(data?.finalProcessedData || []);
      setSourceAliasIds(data?.sourceAliasIds);
      // }
    } catch (err) {
    } finally {
      setIsLoading(false);
      if (
        actionMetrics?.data &&
        (!actionMetrics?.data?.actionList ||
          actionMetrics?.data?.actionList.length === 0)
      ) {
        dispatch(fetchActionMetrics(customerId));
      }
    }
  };

  return (
    <div className="m-3">
      <ActionTypeTab
        activeTarget={actionType}
        handleChange={handleActionTypeChange}
      />
      {actionType === "Recommended Actions" && (
        <RecommendedActions
          isLoading={isLoading}
          actionMetricsData={actionMetricsData}
          sourceAliasIds={sourceAliasIds}
          handleChange={handleActionTypeChange}
          domaUrlsMapping={{
            ...brandDomains,
            ...brandProductDomains,
          }}
          actionableData={actionableData}
        />
      )}
      {actionType === "Actions List" && (
        <>
          <br />
          <ActionsView />
          {/* <ActionList/> */}
        </>
      )}
    </div>
  );
}
